import React from 'react';

interface FormCaptionProps {
  children: string;
  className?: string;
}

export const FormCaption = ({ children, className = '' }: FormCaptionProps) => (
  <div
    className={`text-base-black text-center font-display text-[18px] md:text-[24px] font-medium mx-auto mb-[8px] container w-max ${className}`}
  >
    {children}
  </div>
);
